import { Component, h } from '@stencil/core';

@Component({
    tag: 'cp-demo',
    styleUrl: 'cp-demo.css',
    shadow: false,
})

export class CpDemo {
    render() {
        return (
            <div>
                <card-template>
                    <h2 slot="cp-header">hello from header slot</h2>
                    <slot> hello from default slot</slot>
                    <h3 slot="cp-subheading">hello from sub heading slot</h3>
                </card-template>

                <schema-slot schema={[
                    { "name": "save", "label": "Save", "type": "danger" },
                    { "name": "delete", "label": "Delete", "type": "danger" }
                ]}>
                </schema-slot>
            </div>

        );
    }
}

